import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserUtils } from '@azure/msal-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

/**
 * Dentro de un iframe, la aplicación no arranca.
 *
 * MSAL renueva la sesión en silencio cargando el `redirectUri` en un **iframe
 * oculto** y leyendo de ahí la respuesta de Azure. Nuestro `redirectUri` es
 * `/auth/callback`, que no es una página: es una ruta de Angular, así que el
 * iframe se bajaba la aplicación entera y la arrancaba de nuevo.
 *
 * Esa copia hacía dos cosas, las dos malas. Procesaba el hash por su cuenta
 * —y se lo sacaba de las manos al que había pedido la renovación, que se
 * quedaba esperando hasta agotar el tiempo— y encima navegaba al tablero,
 * pedía datos y volvía a renovar: otro iframe, otra copia. La pantalla se
 * recargaba sola sin parar y terminaba mostrando el enchufe desconectado.
 *
 * Salteando el arranque, el iframe queda en un documento inerte: MSAL lee el
 * hash de la URL y lo cierra, que es exactamente para lo que lo abrió.
 */
if (!BrowserUtils.isInIframe()) {
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
}
